import React, { Fragment, useState, useEffect } from 'react';

import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
// import { submitForm } from './search/redux/actions/actions';
import { useTranslation } from 'react-i18next';
import Select2Wrapper from '../Select2Wrapper';
import Cookies from 'js-cookie';
import OmantelVisaHeader from './OmantelVisaHeader';

import '@fontsource/ibm-plex-sans/400.css';  // Regular weight
import '@fontsource/ibm-plex-sans/500.css';  // Medium weight
import '@fontsource/ibm-plex-sans/600.css';  // Semi-bold weight


const { config } = require('../api/api');

function OmantelVisaInfo() {

   const [isHovered,setIsHovered]=useState(false);
     const [omrAmount, setOmrAmount] = useState('');
       const [searchResult, setSearchResult] = useState(false);
       const [searchData,setSearchData]=useState(null);
       const [lnstr,setlnstr]=useState("en");
       const base_url = config.baseURL;
         const { t,i18n } = useTranslation();
         const [loading,setLoading]=useState(false);
         const [userDetails,setUserDetails]=useState(null);
         const[imageUrl,setImageUrl]=useState("");
       
 useEffect(async () => {
    debugger
    const storedResultString = sessionStorage.getItem('VisaSearchResult');
    if (storedResultString !== "undefined") {
      const storedResult = JSON.parse(storedResultString);
      debugger;
      if(storedResult != null && storedResult != undefined && storedResult.fee != null && storedResult.fee != undefined){
        await getOMRAmount(storedResult.fee,storedResult.currency);
      }
     
      setSearchResult(storedResult);
    }
  }, []);

  useEffect(()=>{
  console.log(searchResult);
  },[searchResult])
  const getOMRAmount = (amount, currency) => {
    debugger
        fetch(base_url+'/amount_convertion', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "amount":amount,
            "currency": currency
        }),
        })
          .then(response => response.json())
          .then(data => {
            debugger;
            if(data['message'] == 'success'){
              var result = data['result'];
              var split_data = result.split('.');
              var convertion_amount = '';
              if(split_data[1].length >= 3){
                convertion_amount = split_data[0] +'.'+ result.split('.')[1].substring(0, 3);
              }else{
                convertion_amount = result;
              }
              setOmrAmount(convertion_amount);
            }
           
            // setVendorKey(data.result[0].vendor_key);
          })
          .catch(error => {
            console.error('Error posting data:', error);
          });
       
      };

    const handlePreviousBtn = (e) => {
        e.preventDefault();
        const  href1=`/omantel-visa?email=${userDetails?.email}&firstname=${userDetails?.first_name}&lastname=${userDetails?.last_name}&locale=${userDetails?.locale}`;
 
        window.location.href = href1;
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        window.location.href = "/omantel-visaform"
    }
    const handleBtnHover=()=>{
        setIsHovered(true)
    }
    const handleBtnStopHover=()=>{
        setIsHovered(false)
    }
      useEffect(()=>{
        debugger
                        const getVisaDetails=sessionStorage.getItem("visaInfo");
                        if(getVisaDetails){
                          const parseVisaInfo=JSON.parse(getVisaDetails);
                        
                        setSearchData(parseVisaInfo);
                        if(parseVisaInfo?.locale){
                          i18n.changeLanguage(parseVisaInfo?.locale);
                        setlnstr(parseVisaInfo?.locale);
                        }
                        }
                      },[])



  // Function to update HTML dir attribute based on language
  const updateHtmlDirAttribute = () => {
    document.documentElement.dir = i18n.dir(); // Set document direction
  };

  // Update HTML dir attribute when component mounts and language changes
  useEffect(() => {
    updateHtmlDirAttribute();
  }, [i18n.language]);

   useEffect(()=>{
        const visa_user=  sessionStorage.getItem("visaInfo");
        if(visa_user!==undefined){
          const parseUserDetails=JSON.parse(visa_user);
          setUserDetails(parseUserDetails);
        }
      },[])
   useEffect(()=>{
         const flagImg= sessionStorage.getItem("CountryFlags");
         if(flagImg){
             const img_parse=JSON.parse(flagImg);
             setImageUrl(img_parse?.to);
         }
   },[])
      

    return (
      <>
 
        <div style={{backgroundColor:"#fafafa",fontFamily: 'IBM Plex Sans'}}>
        <OmantelVisaHeader />
            <div className='container' style={{ color: "#212529" }}>

                <div style={{ }}>
                   
                        <div className='row' style={{ display: "flex",justifyContent:'center',height:"80vh", alignContent: 'center' }}>
                            <div className='col-md-6 col-12'>
                                <table className='visa_information_style'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {t('Destination')}
                                            </td>
                                            <td>
                                                <b>:&nbsp;{t(searchData?.destinationCountry)}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {t("Citizenship")}
                                            </td>
                                            <td>
                                                <b>:&nbsp;{t(searchData?.passportCountry)}</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='card px-2 py-3 border shadow' 
                                style={{backgroundColor:"#fff"}}
                                >
                                    <div className='row'>
                                    
                                        <div className='col-md-4 col-4 '>
                                            <img className='country_flag' alt="Omantel" src={imageUrl}  />
                                        </div>
                                        <div className='col-md-8 col-8'>
                                            <h4>{t("Tourist")} {t("e-visa")}</h4>

                                            {(searchResult?.fee) ? <div>{t("Visa")} {t("Charges")} :
                                             <b>{searchResult?.fee} {searchResult['currency']}</b> 
                                             ({omrAmount} OMR)</div> : ''}

{(searchResult?.fee) ? <div>{t("Max")} {t("Stay")}: <b>{searchResult['max_stay']} Days</b></div> : ''}
{(searchResult['fee']) ? <></> : (searchResult['label'] === 'Visa Required') ? <span style={{ color: "red" }}>{t('Visa')} {t('Required')}. {t('Omantel')} {t('is')} {t('unable')} {t('to')} {t('offer')} {t('this')} {t('service')} {t('for')} {t('now')}.</span> : (searchResult['label'] !== 'Visa Required') ? <div >{t(searchResult['label'])}<br /></div> : ''}

{/* 
{(searchResult['fee']) ? <div><button type="button" className="btn btn-primary rounded-pill mt-4 text-white py-1 px-4" onClick={() => handleClick("Tourist e-visa")}>{(lnstr === 'en' ? 'Apply' : 'يتقدم')}</button></div> : ''} */}

                                            {/* <div>Visa Charges : <b>87 USD</b> (33.408 OMR)</div>
                                            <div>Max Stay : <b>90.0 Days</b></div> */}
                                            

                                        </div>
<div className='visa_search_result col-12'>

{/* {(searchResult['fee'] === '') && (searchResult['label'] === 'Visa Required' || searchResult['label'] === 'eVisa') ? <div><br /><b style={{ color: "black" }}>{t('How')} {t('can')} {t('I')} {t('get')} {t('this')} {t('visa')}?<br /></b> To learn how to get this visa, please reach out to <a href={searchResult['embassy_url']} target='blank' style={{ color: "rgb(255, 120, 0)" }}>the local embassy or consultate</a></div> : ''} */}
{/* {(searchResult['fee'] === '') && (searchResult['label'] === 'Visa Required' || searchResult['label'] === 'eVisa') ? <div className='text-danger'><br />
{t('Omantel')} {t('is')} {t('unable')} {t('to')} {t('offer')} {t('this')} {t('service')} {t('for')} {t('now')}.
</div> : ''} */}

{(searchResult['fee'] === '') && (searchResult['label'] !== 'Visa Required' && searchResult['label'] !== 'eVisa') ? <div><br /><b style={{ color: "black", "fontSize": "15px" }}>{t("You")} {t("are")} {t("good")} {t("to")} {t("go!")}<br /></b> {t("You")} {t("don't")} {t("need")} {t("a")} {t("Visa")} {t("for")} <b>{t(searchData?.destinationCountry)}</b> {t("if")} {t("you")} {t("have")} {t("a")} {t("passport")} {t("from")} <b>{t(searchData?.passportCountry)}</b></div> : ''}

{(!searchResult) ? <span style={{ color: "red" }}>{t('Omantel')} {t('is')} {t('unable')} {t('to')} {t('offer')} {t('this')} {t('service')} {t('for')} {t('now')}.</span> : ''}

</div>
                                        <div className='col-md-4 col-4'></div>
                                        <div className='col-md-8 col-8'>
                                       { (searchResult?.fee) ?
                                        <div>
                                        <button type="button" style={{ backgroundColor:  '#FF7900',
                                            color: '#fff',fontWeight:"400",height:"33px",width:"120px" }}  disabled={loading} class=" rounded-pill mt-4  py-1 px-4"  onClick={handleSubmit}>{!loading?<span>{t("Apply")}</span>:<div class="d-flex  justify-content-center"><div class="omantel-loader"></div></div>}</button>

                                            </div>:
                                            <>

                                            </>
                                            }
                                            
                                    </div>
</div>
                                </div>
<div className='mt-4 d-flex justify-content-center'>
                                      <button style={{ color: "#FF7900", backgroundColor: '#FFF2E6',padding:"2px 10px" }} className='px-4' onClick={handlePreviousBtn} >
                                      <i class="fas fa-arrow-left"></i>
                                      </button>
                                </div>
                               
                            </div>

                        </div>

                </div>
            </div>
        </div>
      </>
    )
}
export default OmantelVisaInfo;